export enum SpaceRoutes {
  Market = 'market',
  Markets = 'markets',
  Collection = 'collection/:collectionId',
}
